import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

import { AppVersionProvider } from './../../providers/app-version/app-version';

@IonicPage()
@Component({
  selector: 'page-modal-about',
  templateUrl: 'modal-about.html'
})
export class ModalAboutPage {
  type: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    public appVersionPrvdr: AppVersionProvider
  ) {
    this.appVersionPrvdr.getType().then(type => {
      this.type = type;
    });
  }

  onDismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modal-about/modal-about.ts